module.exports = __webpack_public_path__ + "img/services4.204310b4.jpg";